import React from 'react'
import { GroundPlanContext } from 'src/contexts'
import Background from './Background'
import BackgroundMouseEvents from './BackgroundMouseEvents'
import Points from './Points'
import styles from './GroundPlan.scss'

const GroundPlan = () => {
  // read plan context
  const { nodeRef, width, height } = GroundPlanContext.use()
  return (
    <div ref={nodeRef} className={styles.mapContainer}>
      <div className={styles.map}>
        <svg width={width} height={height}>
          <Background />
          <BackgroundMouseEvents />
          <Points />
        </svg>
      </div>
    </div>
  )
}

export default GroundPlan
